import React from "react";

export const LazyAuditLog = React.lazy(
    () =>
        import(
            /* webpackChunkName: "AuditLog" */
            "./AuditLog"
        )
);
